import React from "react";
import styles from"../styles/signupcard.module.css";
import blwoman from '../assets/images/blwoman.png'
import count from "../assets/svgs/page-counter.svg";

const LoginCard = (props) => {

const image = props.image;




  return (
    <div className={styles.busgirl}>
      <div className={styles.bus}>
        <img src={image} alt="" className={styles.blgirl}/>
      </div>
      <div>
        <div className={styles.logo}></div>
        <div className={styles.imgCard}>
          I’m extremely happy that I know this<br></br> application. I’ve wished
          for it for so long.<br></br> Booking buses is way easier now.
          <div className={styles.loginInfo}>
            <div className={styles.fro}></div>
            <div className={styles.info}>
              <h4>Michelle Dada</h4>
              <p>User Experience Designer</p>
            </div>
            <div className={styles.count}>
              <img src={count} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginCard;
